import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Title, Text, Stack } from '@mantine/core'
import { useAuthStore } from '../../stores/authStore'
import { FlaggedAccountsCard } from './FlaggedAccountsCard'
import { PasskeyAdoptionCard } from './PasskeyAdoptionCard'

export function DashboardView() {
  const { user } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (user && user.role !== 'Admin') {
      navigate('/', { replace: true })
    }
  }, [user, navigate])

  return (
    <Stack gap="md">
      <Title order={2}>Welcome</Title>
      <Text c="dimmed">
        Welcome to the Accounts administration dashboard.
      </Text>

      <FlaggedAccountsCard />
      <PasskeyAdoptionCard />
    </Stack>
  )
}
